export enum SEO_LINK_TYPE {
    PAGE_URL = 'pageUrl',
    CURRENT_PATH = 'currentPath',
    WITH_DYNAMIC_SEGMENT = 'withDynamicSegment',
    DISABLED = 'disabled'
}
